// extracted by mini-css-extract-plugin
export default {"modalContainer":"Rx","fadeRight":"Sx","fadeUp":"Tx","topShelf":"Ux","newFlavorBadge":"Vx","transparentText":"Wx","cancelButton":"Xx","invisibleLink":"Yx","closeIcon":"Zx","linkContainer":"ay","hed":"by","image":"cy"};
    if(module.hot) {
      // 1715632475063
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  